import * as common from './common.json';

export const pt = {
  common,
};
